export default {
    day: '2024-11-23',
    content: {
        horde: [
            {
                unlock: 'hordeBrickTower',
                type: 'balance',
                text: '426'
            },
        ],
        farm: [
            {
                type: 'bugfix',
                text: '427'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '412'
            },
            {
                unlock: 'farmCropExp',
                type: 'balance',
                text: '413'
            },
        ],
        event: [
            {
                unlock: 'snowdownEvent',
                type: 'new',
                text: '415'
            },
            {
                unlock: 'snowdownEvent',
                type: 'change',
                text: '416'
            },
            {
                unlock: 'snowdownEvent',
                type: 'new',
                text: '417'
            },
            {
                unlock: 'snowdownEvent',
                type: 'change',
                text: '418'
            },
            {
                unlock: 'snowdownEvent',
                type: 'balance',
                text: '419',
                balance: 'nerf',
                before: '5',
                after: '8'
            },
            {
                unlock: 'snowdownEvent',
                type: 'balance',
                text: '420',
                balance: 'buff',
                before: '50',
                after: '30'
            },
            {
                unlock: 'snowdownEvent',
                type: 'balance',
                text: '421',
                balance: 'buff',
                before: '140',
                after: '55'
            },
            {
                unlock: 'snowdownEvent',
                type: 'remove',
                text: '422'
            },
            {
                unlock: 'snowdownEvent',
                type: 'change',
                text: '423'
            },
            {
                unlock: 'snowdownEvent',
                type: 'new',
                text: '424'
            },
            {
                unlock: 'snowdownEvent',
                type: 'clarity',
                text: '425'
            },
        ],
        gallery: [
            {
                unlock: 'galleryInspiration',
                type: 'balance',
                text: '402',
                balance: 'change',
                before: '+0.75x',
                after: '+0.5x (+0.1x)'
            },
            {
                unlock: 'galleryInspiration',
                type: 'balance',
                text: '403'
            },
            {
                unlock: 'galleryInspiration',
                type: 'balance',
                text: '405',
                balance: 'buff',
                before: '+0.1x',
                after: '+0.12x'
            },
            {
                unlock: 'galleryDrums',
                type: 'balance',
                text: '399',
                balance: 'nerf',
                before: '+3 (+1)',
                after: '+2'
            },
            {
                unlock: 'galleryCanvas',
                type: 'balance',
                text: '400'
            },
            {
                unlock: 'galleryDrums',
                type: 'balance',
                text: '401',
                balance: 'buff',
                before: '+0.25x',
                after: '+0.35x'
            },
            {
                unlock: 'galleryCanvas',
                type: 'balance',
                text: '404',
                balance: 'buff',
                before: '+0.18x',
                after: '+0.25x'
            },
            {
                unlock: 'galleryShape',
                type: 'bugfix',
                text: '406'
            },
            {
                unlock: 'galleryShape',
                type: 'context',
                text: '411'
            },
            {
                unlock: 'galleryShape',
                type: 'balance',
                text: '408'
            },
            {
                unlock: 'galleryShape',
                type: 'balance',
                text: '409',
                balance: 'nerf',
                before: '180s (+7s)',
                after: '30s (+3.7s)'
            },
            {
                unlock: 'galleryShape',
                type: 'balance',
                text: '410'
            },
            {
                unlock: 'galleryCanvas',
                type: 'balance',
                text: '407',
                balance: 'nerf',
                before: '+25',
                after: '+10'
            },
        ],
        village_1: [
            {
                unlock: 'villageSpecialIngredient',
                type: 'qol',
                text: '414'
            },
        ],
    }
}
